export enum TableTypeEnum {
  PROJECTS = "projects",
  CLIENTS = "clients",
  COMPANIES = "companies",
  TASKS = "tasks",
  FINANCE = "finance",
  SELLING = "selling",
  COMPANY_EMPLOYEES = "company-employees",
  STATISTIC_CLIENTS = "statistic-clients",
  STATISTIC_USER_ITEM = "statistic-user-item",
  TEAM_USERS = "team-users",
}

export type TableType = (typeof TableTypeEnum)[keyof typeof TableTypeEnum];

export const tableColumnType = {
  [TableTypeEnum.PROJECTS]: {
    name: "Проєкти",
    columns: [
      { key: "isChecked", label: "", visible: true },
      { key: "id", label: "", visible: false },
      { key: "name", label: "Назва", visible: true },
      { key: "projectStageName", label: "Етап проекту", visible: true },
      { key: "allIncome", label: "Надходження", visible: true },
      { key: "priorityName", label: "Пріорітет", visible: true },
      { key: "createdAt", label: "Дата початку", visible: true },
      { key: "deadline", label: "Дата закінчення", visible: true },
      { key: "description", label: "Опис", visible: true },
      { key: "contactEmail", label: "Контакт", visible: true },
      { key: "companyName", label: "Компанія", visible: true },
    ],
  },
  [TableTypeEnum.TASKS]: {
    name: "Завдання",
    columns: [
      { key: "isChecked", label: "", visible: true },
      { key: "id", label: "", visible: false },
      { key: "name", label: "Назва", visible: true },
      { key: "deadline", label: "Дедлайн", visible: true },
      { key: "createdAt", label: "Дата створення", visible: true },
      { key: "status", label: "Статус", visible: true },
      { key: "priorityName", label: "Пріорітет", visible: true },
      { key: "createdBy", label: "Ким створено", visible: true },
      { key: "usersEmails", label: "Виконавці", visible: true },
      { key: "project", label: "Проєкт", visible: true },
      { key: "projectId", label: "Проєкт", visible: true },
      { key: "selling", label: "Продажі", visible: true },
      { key: "sellingId", label: "Продажі", visible: true },
      { key: "description", label: "Опис", visible: true },
    ],
  },
  [TableTypeEnum.FINANCE]: {
    name: "Фінанси",
    columns: [
      { key: "isChecked", label: "", visible: true },
      { key: "id", label: "", visible: false },
      { key: "name", label: "Назва", visible: true },
      { key: "amount", label: "Сума", visible: true },
      { key: "valutaCode", label: "Валюта", visible: true },
      { key: "typeName", label: "Тип", visible: true },
      { key: "project", label: "Проєкт", visible: true },
      { key: "projectId", label: "Проєкт", visible: true },
      { key: "selling", label: "Продажі", visible: true },
      { key: "sellingId", label: "Продажі", visible: true },
      { key: "date", label: "Дата", visible: true },
      { key: "responsibleEmail", label: "Відповідальний", visible: true },
      { key: "comment", label: "Опис", visible: true },
    ],
  },
  [TableTypeEnum.COMPANIES]: {
    name: "Компанії",
    columns: [
      { key: "isChecked", label: "", visible: true },
      { key: "name", label: "Назва", visible: true },
      { key: "customerType", label: "Тип", visible: true },
      { key: "description", label: "Опис", visible: true },
      { key: "contactEmail", label: "Контакт", visible: true },
      { key: "siteLink", label: "Посилання на сайт", visible: true },
    ],
  },
  [TableTypeEnum.CLIENTS]: {
    name: "Клієнти",
    columns: [
      { key: "isChecked", label: "", visible: true },
      { key: "firstName", label: "Ім'я", visible: true },
      { key: "lastName", label: "Прізвище", visible: true },
      { key: "phone", label: "Телефон", visible: true },
      { key: "email", label: "Email", visible: true },
      { key: "customerType", label: "Тип", visible: true },
      { key: "companyName", label: "Компанія", visible: true },
      {
        key: "responsibleUserEmail",
        label: "Відповідальний контакт",
        visible: true,
      },
    ],
  },
  [TableTypeEnum.COMPANY_EMPLOYEES]: {
    name: "Контакти компанії",
    columns: [
      { key: "isChecked", label: "", visible: true },
      { key: "fullName", label: "Ім'я Прізвище", visible: true },
      { key: "email", label: "Email", visible: true },
      { key: "phoneNumber", label: "Телефон", visible: true },
    ],
  },
  [TableTypeEnum.SELLING]: {
    name: "Продажі",
    columns: [
      { key: "isChecked", label: "", visible: true },
      { key: "id", label: "", visible: false },
      { key: "name", label: "Назва", visible: true },
      { key: "stageName", label: "Етап", visible: true },
      { key: "amount", label: "Бюджет", visible: true },
      { key: "valutaCode", label: "Валюта", visible: true },
      { key: "createdAt", label: "Дата початку", visible: true },
      { key: "deadline", label: "Дата закінчення", visible: true },
      { key: "clientEmail", label: "Клієнт", visible: true },
      { key: "reponsibleEmail", label: "Відповідальний", visible: true },
      { key: "project", label: "Проєкт", visible: true },
      { key: "description", label: "Опис", visible: true },
    ],
  },
  [TableTypeEnum.STATISTIC_CLIENTS]: {
    name: "Останні додані клієнти",
    columns: [
      { key: "firstName", label: "Ім'я", visible: true },
      { key: "lastName", label: "Прізвище", visible: true },
      { key: "customerType", label: "Тип", visible: true },
      { key: "phone", label: "Телефон", visible: true },
      { key: "email", label: "Email", visible: true },
      { key: "companyName", label: "Компанія", visible: true },
    ],
  },
  [TableTypeEnum.TEAM_USERS]: {
    name: "Учасники команди",
    columns: [
      { key: "fullName", label: "Прізвище / Ім'я", visible: true },
      { key: "email", label: "Email", visible: true },
      { key: "description", label: "Опис", visible: true },
    ],
  },
  [TableTypeEnum.STATISTIC_USER_ITEM]: {
    name: "Активність користувачів",
    columns: [
      { key: "fullName", label: "Прізвище / Ім'я", visible: true },
      { key: "projectsCount", label: "Проєкти", visible: true },
      { key: "tasksCount", label: "Завдання", visible: true },
      { key: "commentsCount", label: "Коментарі", visible: true },
    ],
  },
};

export enum DropdownTypeEnum {
  PANEL_ITEMS = "panel-items",
  LANGS = "langs",
  NUMBERS = "numbers",
  PERIODS = "periods",
  CURRENCY = "currency",
  COMPANY = "company",
  CLIENT = "client",
  CONTACT = "contact",
  MEMBERS = "members",
  PROJECT_ROLES = "project-roles",
  STAGE = "stage",
  SELLING_STAGE = "selling-stage",
  FINANCE_TYPES = "expense-income-types",
  DATE = "date",
  PROJECTS = "projects",
  SELLINGS = "sellings",
  FINANCE_TYPE = "finance-type",
}
